module.exports = __webpack_public_path__ + "pdf/industrial.5fed7fb.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/industrial.pdf
// module id = Niaf
// module chunks = 0